/* eslint-disable */
import AWS from 'aws-sdk';
import axios from 'axios';
import sigV4Client from './sigV4Client';
import { isLoggedIn } from './AuthService';

export default async function ({
  endpoint, path = '/', method = 'GET', headers = {}, queryParams = {}, body,
}) {
  // check if logged in
  if (!await isLoggedIn()) {
    throw new Error('User is not logged in!');
  }

  // get signed request
  const signedRequest = sigV4Client.newClient({
    accessKey: AWS.config.credentials.accessKeyId,
    secretKey: AWS.config.credentials.secretAccessKey,
    sessionToken: AWS.config.credentials.sessionToken,
    region: 'eu-west-2',
    endpoint,
  }).signRequest({
    method,
    path,
    headers,
    queryParams,
    body,
  });

  // get headers and body
  headers = signedRequest.headers;
  body = body ? JSON.stringify(body) : body;

  // fetch data
  const results = await axios({
    method,
    url: signedRequest.url,
    headers,
    data: body,
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.data;
}
